import { createMuiTheme } from '@material-ui/core';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import { ptBR } from '@material-ui/core/locale';

const theme = createMuiTheme(
  {
    palette,
    typography,
    overrides
  },
  ptBR
);

export default theme;
